import { useContext } from 'react';

import { SortComponent } from './SorterComponent/SorterComponent';
import { GoodsListContext } from '../Context/GoodsListContext';

export const SortersList = () => {
  const {
    state: { sorting },
    dispatch,
  } = useContext(GoodsListContext);

  const handleChange = (event) => {
    dispatch({ type: event.target.id, payload: { sorting: event.target.id } });
  };

  const handleClick = () => {
    dispatch({ type: 'reset' });
  };

  return (
    <div className="mt-2 md:mt-4">
      <h3 className="font-crimson font-bold text-base md:text-lg leading-5">Sorting</h3>
      <div>
        {['Price ↑', 'Price ↓', 'By name, A-Z', 'By name, Z-A'].map((sort, idx) => (
          <SortComponent key={sort + idx} name={sort} handleSorter={handleChange} isActive={sorting === sort} />
        ))}
      </div>
      <hr className="h-0.5 w-90 border-none bg-gradient-to-r from-grStart to-grEnd" />
      <h3 className="font-crimson font-bold text-base md:text-lg leading-5 mt-4">To forget all settings say</h3>
      <button
        className="h-12 w-28 my-2 rounded-3xl p-1 bg-gradient-to-r from-grStart to-grEnd font-poppins font-normal text-lg text-font leading-5 border border-transparent tracking-wider hover:text-borderColor hover:bg-none duration-300 hover:border-borderColor"
        onClick={handleClick}>
        Obliviate
      </button>
    </div>
  );
};
